// this must be manually kept in sync with the bed-count columns in the capacity report at the backend
export interface IBedType {
  type: string;
  name: string;
  formerly: string;
}
export const BedTypes: IBedType[] = [
  {
    name: 'A',
    type: 'A',
    formerly: 'Long Term Care',
  },
  {
    name: 'B',
    type: 'B',
    formerly: 'Designated Supportive Living',
  },
  {
    name: 'B-Secure',
    type: 'BSecure',
    formerly: 'Designated Supportive Living 4-D',
  },
  {
    name: 'C',
    type: 'C',
    formerly: 'Palliative and End-of-Life Care',
  },
];
